module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', _vm._l((_vm.inspection_externals), function(inspection_unmarked) {
    return (inspection_unmarked.inspection_type == 'UNMARKED' && inspection_unmarked.section_id == _vm.section_id) ? _c('tr', [_c('td', [_vm._v(_vm._s(inspection_unmarked.element.name))]), _vm._v(" "), (inspection_unmarked.damages && inspection_unmarked.damages.length > 0) ? _c('td', _vm._l((inspection_unmarked.damages), function(damage) {
      return _c('div', {
        staticClass: "red"
      }, [_vm._v("\n                " + _vm._s(damage.name) + "\n            ")])
    })) : _c('td', [_c('div', {
      staticClass: "green"
    }, [_vm._v("В порядке")])]), _vm._v(" "), _c('td', [(inspection_unmarked.element.type == 'PANEL_ROOF') ? _c('button', {
      staticClass: "btn btn-sm btn-edit",
      on: {
        "click": function($event) {
          inspection_unmarked.photo.display = !inspection_unmarked.photo.display
        }
      }
    }, [_vm._v("Смотреть фото")]) : _vm._e(), _vm._v(" "), (inspection_unmarked.photo.display) ? _c('div', {
      staticClass: "inspection-photo"
    }, [_c('a', {
      attrs: {
        "href": inspection_unmarked.photo.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": inspection_unmarked.photo.url
      }
    })])]) : _vm._e()])]) : _vm._e()
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c3cc9fb4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3cc9fb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionExternalUnmarked.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c3cc9fb4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionExternalUnmarked.vue
// module chunks = 0